import React, { memo, useCallback } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Icons from "../../../assets/Icons";
import {
  ensureCopilotSession,
  updateCopilotValue,
} from "../hooks/useCopilotValue";

const DOCK_DOT_COLOR = "#00C950";

const CopilotDock = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const onPress = useCallback(() => {
    ensureCopilotSession();
    updateCopilotValue({ isPanelOpen: true });
  }, []);

  return (
    <Box
      component="button"
      onClick={onPress}
      aria-label={t("Copilot_Dock_A11y")}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 2,
        py: 1.25,
        width: 160,
        height: 46,
        borderRadius: "23px",
        border: "1px solid rgba(255,255,255,0.25)",
        bgcolor: theme.palette.custom?.background?.brand ?? "primary.main",
        color: "white",
        cursor: "pointer",
        boxShadow: "0 3px 6px rgba(0,0,0,0.22)",
        outline: "none",
        "&:hover": { opacity: 1 },
        "&:active": { opacity: 0.95 },
      }}
    >
      <Icons.CopilotIconWhite width={18} height={18} style={{ flexShrink: 0 }} />
      <Typography
        noWrap
        sx={{
          flex: 1,
          fontSize: 14,
          fontWeight: 600,
          color: "inherit",
          lineHeight: 1,
        }}
      >
        {t("Copilot_Name")}
      </Typography>
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          bgcolor: DOCK_DOT_COLOR,
          flexShrink: 0,
        }}
      />
    </Box>
  );
};

export default memo(CopilotDock);
